interface CardWithImageProps {
  title: string
  body: string
  imageSrc: string
  className?: string
}

export function CardWithImage({ 
  title, 
  body, 
  imageSrc,
  className = '' 
}: CardWithImageProps) {
  return (
    <div className={`relative overflow-hidden rounded-lg ${className}`}>
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={imageSrc}
          alt=""
          className="h-full w-full object-cover"
        />
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/20 backdrop-blur-[2px]" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 p-6">
        <h3 className="text-xl font-semibold mb-2 text-white">{title}</h3>
        <p className="text-gray-100">{body}</p>
      </div>
    </div>
  )
} 